import React, { useCallback } from 'react';
import cl from 'classnames';

import { IconsEnum } from '../../../../../assets/icons/types';
import { I18nText } from '../../../../../types';

import { Translate } from '../../../../../helpers/Translate';
import { Icon } from '../../../../../helpers/Icon';

interface UniversalFilterSelectItemProps<T> {
  value: T;
  i18nText?: I18nText;
  isSelected?: boolean;
  onChange: (value: T) => void;
}

function UniversalFilterSelectItem<T>({
  value,
  i18nText,
  isSelected,
  onChange
}: UniversalFilterSelectItemProps<T>) {
  const handleClick = useCallback<() => void>(() => {
    onChange(value);
  }, [value, onChange]);

  return (
    <li
      className="text-gray-800 dark:text-gray-200 cursor-default hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-800 focus:text-gray-900 dark:focus:text-gray-100 focus:bg-gray-100 dark:focus:bg-gray-900 select-none relative py-2 pl-8 pr-4 focus:ring-base focus:ring-offset-0"
      onClick={handleClick}
    >
      <span
        className={cl(
          'block truncate',
          isSelected ? 'font-semibold' : 'font-normal'
        )}
      >
        <Translate id={i18nText} />
      </span>
      {isSelected ? (
        <span className="text-blue-600 absolute inset-y-0 left-0 flex items-center pl-1.5">
          <Icon icon={IconsEnum.CHECK} className="h-5 w-5" />
        </span>
      ) : null}
    </li>
  );
}

export default UniversalFilterSelectItem;
